import React from 'react';
import styles from './PriorityLevel.module.css';
import { SentinelPriorityLevel } from '@energybox/react-ui-library/dist/types';

type Props = {
  priority?: SentinelPriorityLevel;
};

const PriorityLevel: React.FunctionComponent<Props> = ({
  children,
  priority = SentinelPriorityLevel.LOW,
}) => (
  <span className={`${styles.root} ${styles[priority.toLowerCase()]}`}>
    {children}
    <span className={styles.circle} />
  </span>
);

export default PriorityLevel;
